module.exports = __webpack_public_path__ + "img/analytic_dislike.93fb624a.svg";